// extracted by mini-css-extract-plugin
export default {"textWrap":"explainer-focus-panel_textWrap__iHvG2"};